import { createSelector } from 'reselect';

export const selectVideoFeed = state => state.get('videoFeed');
export const selectVideos = createSelector(selectVideoFeed, videoFeed =>
  videoFeed.get('videos').toJS()
);



// WEBPACK FOOTER //
// ./src/containers/VideoFeed/selectors.js